import React, { useEffect } from 'react';
import Header from '../Component/Header';
import Footer from '../Component/Footer';
import { Link } from 'react-router-dom';
function CBSEDisclosure() {
  useEffect(() => {
    document.title = ' CBSE Mandatory Disclosure-  CARMEL CONVENT SCHOOL, DHARUHERA';
  }, []);
  return (
    <>
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li> CBSE Mandatory Disclosure</li>
              </ul>
            </div>
            <div className="col-lg-12">
              <h2 className="innerheading"> CBSE Mandatory Disclosure</h2>
            </div>
          </div>
          <div className="row">
            <div class="col-lg-12"><h6>A: GENERAL INFORMATION</h6><div class="table-responsive maintable"><table class="table"><thead>
              <tr>
                <th width="10%" class="text-center">S.NO</th><th width="60%" class="text-center">INFORMATION</th><th width="30%" class="text-center">DETAILS</th></tr>
            </thead><tbody>
                <tr>
                  <td>1 </td>
                  <td>NAME OF THE SCHOOL </td>
                  <td>Carmel Convent School, dharuhera</td>
                </tr>

                <tr>
                  <td>2 </td>
                  <td>AFFILIATION NO.(IF APPLICABLE) </td>
                  <td> - </td>
                </tr>

                <tr>
                  <td>3 </td>
                  <td>Recognition No. </td>
                  <td>PSR122022138</td>
                </tr>

                <tr>
                  <td>4 </td>
                  <td>COMPLETE ADDRESS WITH PIN CODE</td>
                  <td>  Alawalpur, near Jyoti Hotel, Nandrampur Bass Road,
                    Teh. Dharuhera, Distt. Rewari, Haryana - 123106</td>
                </tr>

                <tr>
                  <td>5</td>
                  <td> PRINCIPAL NAME &amp; QUALIFICATION: </td>
                  <td>  Sr. Mary Supreeta</td>
                </tr>

                <tr>
                  <td>6</td>
                  <td> SCHOOL EMAIL ID</td>
                  <td><a href="mailto:carmelschooldharuhera@gmail.com">carmelschooldharuhera@gmail.com</a></td>
                </tr>

                <tr>
                  <td>7 </td>
                  <td>CONTACT DETAILS (LANDLINE/MOBILE)</td>
                  <td><a href="tel:+91 8168540345">+91 8168540345</a></td>
                </tr>
              </tbody></table></div><h6>B: DOCUMENTS AND INFORMATION</h6><div class="table-responsive maintable"><table class="table"><thead>
                <tr>
                  <th width="10%" class="text-center">S.NO </th><th width="60%" class="text-center">DOCUMENTS/INFORMATION </th><th width="30%" class="text-center">UPLOAD DOCUMENTS</th></tr>
              </thead>
                <tbody>
                  <tr>
                    <td>1 </td>
                    <td>COPIES OF AFFILIATION/UPGRADATION LETTER AND RECENT EXTENSION OF AFFILIATION, IF ANY </td>
                    <td><a href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/pdf/Upgradation.pdf" target="_blank">View</a></td>
                  </tr>

                  <tr>
                    <td>2 </td>
                    <td>COPIES OF SOCIETIES/TRUST/COMPANY REGISTRATION/RENEWAL CERTIFICATE </td>
                    <td><a href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/pdf/TrustRegistrationCerti.pdf" target="_blank">View</a></td>
                  </tr>

                  <tr>
                    <td>3 </td>
                    <td>COPY OF NO OBJECTION CETIFICATE (NOC) ISSUED </td>
                    <td><a href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/pdf/noc.pdf" target="_blank">View</a></td>
                  </tr>

                  <tr>
                    <td>4 </td>
                    <td>COPIES OF RECOGNITION CERTIFICATE UNDER RTE ACT, AND ITS RENEWAL, IF APPLICABLE</td>
                    <td><a href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/pdf/Recognition.pdf" target="_blank">View</a></td>
                  </tr>

                  <tr>
                    <td>5 </td>
                    <td>COPY OF VALID  BUILDING CERTIFICATE </td>
                    <td><a href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/pdf/SafteyBuilding.pdf" target="_blank">View</a></td>
                  </tr>

                  <tr>
                    <td>6 </td>
                    <td>COPY OF VALID FIRE SAFETY CERTIFICATE </td>
                    <td><a href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/pdf/FireSafetyCertificate.pdf" target="_blank">View</a></td>
                  </tr>

                  <tr>
                    <td>7 </td>
                    <td>COPY OF THE DEO CERTIFICATE SUBMITTED BY THE SCHOOL FOR AFFILIATION</td>
                    <td><a href="#" target="_blank">View </a></td>
                  </tr>

                  <tr>
                    <td>8 </td>
                    <td>COPIES OF VALID WATER, HEALTH AND SANITATION CERTIFICATES</td>
                    <td><a href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/pdf/SanitationCert.pdf" target="_blank">View</a></td>
                  </tr>
                  <tr>
                    <td>8 </td>
                    <td>  WATER CERTIFICATES</td>
                    <td><a href="#" target="_blank">View</a></td>
                  </tr>
                </tbody></table></div><h6>C: RESULT AND ACADEMICS</h6><div class="table-responsive maintable"><table class="table"><thead>
                  <tr>
                    <th width="10%" class="text-center">S.NO. </th><th width="60%" class="text-center">S.NO. DOCUMENTS/INFORMATION </th><th width="30%" class="text-center">UPLOAD DOCUMENTS</th></tr>
                </thead><tbody>
                    <tr>
                      <td>1 </td>
                      <td>FEE STRUCTURE OF THE SCHOOL</td>
                      <td><a href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/pdf/FeeStructure.pdf" target="_blank">View</a></td>
                    </tr>

                    <tr>
                      <td>2 </td>
                      <td>ANNUAL ACADEMIC CALENDER</td>
                      <td><a href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/pdf/AcademicCalender.pdf" target="_blank">View</a></td>
                    </tr>

                    <tr>
                      <td>3 </td>
                      <td>LIST OF SCHOOL MANAGEMENT COMMITTEE</td>
                      <td><a href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/pdf/managingcommittee.pdf" target="_blank">View</a></td>
                    </tr>

                    <tr>
                      <td>4 </td>
                      <td>LIST OF PTA MEMBERS</td>
                      <td><a href="#" target="_blank">View</a></td>
                    </tr>

                    {/*  <tr>
          <td>5 </td>
          <td>LAST THREE YEAR RESULT OF THE BOARD EXAMINATION</td>
        <td>CHECK BELOW</td>
        </tr> */}
                  </tbody></table></div>
              {  /* <h6>RESULT CLASS: X</h6>
        <div class="table-responsive maintable"><table class="table"><thead>
          <tr>
          <th class="text-center">S.NO.</th><th class="text-center">YEAR</th><th class="text-center">NO. OF APPEARED STUDENTS</th><th class="text-center">NO. OF STUDENTS PASSED</th><th class="text-center">PASS PERCENTAGE</th><th class="text-center">REMARKS</th></tr>
        </thead><tbody>
          <tr>
          <td>1</td>
          <td>2024</td>
        <td>-</td>
        <td>-</td>
        <td>- </td>
        <td>-</td>
        </tr>
        </tbody></table></div>
        <h6>RESULT CLASS: XII</h6>
        <div class="table-responsive maintable"><table class="table"><thead>
          <tr>
          <th class="text-center">S.NO.</th><th class="text-center">YEAR</th><th class="text-center">NO. OF APPEARED STUDENTS</th><th class="text-center">NO. OF STUDENTS PASSED</th><th class="text-center">PASS PERCENTAGE</th><th class="text-center">REMARKS</th></tr>
        </thead><tbody>
          <tr>
          <td>1</td>
          <td>2024</td>
        <td>-</td>
        <td>-</td>
        <td>-</td>
        <td>-</td>
        </tr>
        </tbody></table></div> */}
              <h6>D: STAFF (TEACHING)</h6><div class="table-responsive maintable"><table class="table"><thead>
                <tr>
                  <th width="10%" class="text-center">S.NO. </th><th width="60%" class="text-center">INFORMATION </th><th width="30%" class="text-center">DETAILS</th></tr>
              </thead><tbody>
                  <tr>
                    <td>1</td>
                    <td>PRINCIPAL</td>
                    <td> 01</td>
                  </tr>

                  <tr>
                    <td>2</td>
                    <td>TOTAL NO. OF TEACHERS</td>
                    <td>13</td>
                  </tr>

                  <tr>
                    <td rowspan="3"></td>
                    <td> PGT</td>
                    <td>-</td>
                  </tr>

                  <tr>
                    <td> TGT</td>
                    <td>4</td>
                  </tr>

                  <tr>
                    <td> PRT </td>
                    <td>9</td>
                  </tr>

                  <tr>
                    <td>3 </td>
                    <td>TEACHERS SECTION RATIO </td>
                    <td>1:20</td>
                  </tr>

                  <tr>
                    <td>4 </td>
                    <td>DETAILS OF SPECIAL EDUCATOR </td>
                    <td> -</td>
                  </tr>

                  <tr>
                    <td>5 </td>
                    <td> DETAILS OF COUNSELLOR AND WELLNESS TEACHER </td>
                    <td> - </td>
                  </tr>
                </tbody></table></div><h6>E: SCHOOL INFRASTRUCTURE</h6><div class="table-responsive maintable"><table class="table"><thead>
                  <tr>
                    <th width="10%" class="text-center">S.NO. </th><th width="60%" class="text-center">INFORMATION </th><th width="30%" class="text-center">DETAILS</th></tr>
                </thead><tbody>
                    <tr>
                      <td>1</td>
                      <td>TOTAL CAMPUS AREA OF THE SCHOOL (IN SQUARE MTR) </td>
                      <td>13,404</td>
                    </tr>

                    <tr>
                      <td>2</td>
                      <td> NO. AND SIZE OF THE CLASS ROOMS (IN SQUARE MTR)</td>
                      <td>81.4 (33 x 26 x 11)</td>
                    </tr>

                    <tr>
                      <td>3</td>
                      <td> NO.ANDSIZEOFLABORATORIESINCLUDING COMPUTER LABS (IN SQ MTR)</td>
                      <td>2 (81.4)(33 x 26 x 11)</td>
                    </tr>

                    <tr>
                      <td>4 </td>
                      <td>INTERNET FACILITY</td>
                      <td> Yes</td>
                    </tr>

                    <tr>
                      <td>5</td>
                      <td> NO. OF GIRLS TOILETS</td>
                      <td>38</td>
                    </tr>

                    <tr>
                      <td>6</td>
                      <td> NO. OF BOYS TOILETS</td>
                      <td>43</td>
                    </tr>

                    <tr>
                      <td>7</td>
                      <td>LINK OF YOUTUBE VIDEO OF THE INSPECTION OF SCHOOL COVERING THE INFRASTRUCTURE OF THE SCHOOL</td>
                      <td><a href="#" target="_blank"><b></b></a></td>
                    </tr>
                  </tbody></table></div></div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default CBSEDisclosure;
